import { useEffect, useState } from 'react';
import env from '../environment';
import { useCoopConfig } from '../components/content/coop-config';

const useEtiquetas = () => {
  const coopConfig = useCoopConfig();
  const [etiquetas, setEtiquetas] = useState({ planta: '', parcela: '', producto: '' });

  const getEtiquetas = async () => {
    const etiquetaParcela = await coopConfig.etiquetaParcelas();
    const etiquetaPlanta = await coopConfig.etiquetaPlantas();
    const etiquetaProducto = await coopConfig.etiquetaProducto();

    setEtiquetas({
      parcela: etiquetaParcela,
      planta: etiquetaPlanta,
      producto: etiquetaProducto,
    });
  };

  // Reacting to the refresh
  useEffect(() => {
    getEtiquetas();
  }, [coopConfig]);

  return {
    etiquetas,
  };
};

export default useEtiquetas;
